export const API_BASE_URL = process.env.NEXT_PUBLIC_BASE_URL || "http://localhost:8080";
export const FLASK_API_URL = process.env.NEXT_PUBLIC_FLASK_API_URL || "http://127.0.0.1:5000";
